// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Search_dropdown__2xQES"};